import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { IInfoProps } from 'services/notificationService';

import { ESettingsAliases, ISetSettingResponse } from '../interfaces';

export const getNotificationData = (
  data: ISetSettingResponse['setSetting'],
  t: TTranslator<TLocalesKeys>,
  alias?: ESettingsAliases
): IInfoProps => {
  switch (alias) {
    case ESettingsAliases.CLUB_NAME:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.club'),
        type: 'success',
        dismiss: 3,
      };

    case ESettingsAliases.SHELL_PASSWORD:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.password'),
        type: 'success',
        dismiss: 3,
      };

    case ESettingsAliases.SHELL_WHITE_LIST_ENABLED: {
      return {
        t,
        title: t('setting.updated'),
        message: t(
          data?.value
            ? 'setting.whitelist.enabled'
            : 'setting.whitelist.disabled'
        ),
        type: data?.value ? 'success' : 'warning',
        dismiss: 3,
      };
    }

    case ESettingsAliases.SHELL_WHITE_LIST:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.whitelist'),
        type: 'success',
        dismiss: 3,
      };

    case ESettingsAliases.SHELL_END_SESSION_ACTION:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.sessionEnd'),
        type: 'success',
        dismiss: 3,
      };

    case ESettingsAliases.SHELL_END_SESSION_TIMEOUT:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.sessionEnd.timeout'),
        type: 'success',
        dismiss: 3,
      };

    case ESettingsAliases.FASTOFF_SMART_LOCK_PWD:
      return {
        t,
        title: t('setting.updated'),
        message: t('setting.updated.smartLock.password'),
        type: 'success',
        dismiss: 3,
      };

    default:
      return {
        t,
        title: t('setting.updated'),
        type: 'success',
        dismiss: 3,
      };
  }
};
